<template>
  <HKLModal
    ref="modal"
    class="hkl-cancel-batch__modal"
    okBtnAction="yes"
    cancelBtnAction="no"
    :title="$t('tenantProjects.submission.cancelBatchMsg')"
    @onOkClick="cancelBatch"
  />
</template>

<script>
import lodash from 'lodash'
import { unref, computed, reactive, toRefs } from 'vue-demi'
import HKLModal from '@/controls/Modal/HKLModal'
import EventBus from '@/utils/eventBus'
import useRouter from '@/router/useRouter'
import { cancelTenantSubmissionBatch } from '@/api/tenantProjects/request'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreActions, useStoreGetters } from '@/store'

export default {
  components: {
    HKLModal,
  },
  setup () {
    const modals = useRefModal()
    const { router } = useRouter()
    const { activeSubmission, currentTenantProject } = useStoreGetters('tenantProject', ['activeSubmission', 'currentTenantProject'])
    const { loadTenantProject } = useStoreActions('tenantProject', ['loadTenantProject'])
    const data = reactive({
      projectId: computed(() => lodash.get(unref(router), 'currentRoute.params.id')),
      currentBatchId: computed(() => lodash.get(unref(activeSubmission), 'id')),
      projectDocsSrcId: computed(() => lodash.get(unref(currentTenantProject), 'projectDocsSrcId')),
    })
    const cancelBatch = async () => {
      await cancelTenantSubmissionBatch(data.currentBatchId, { projectDocsSrcId: data.projectDocsSrcId })
      EventBus.$emit('tenant_docs_refresh', async () => loadTenantProject(data.projectId))
    }
    return {
      ...toRefs(data),
      cancelBatch,
      ...modals,
    }
  },
}
</script>
